import { useState } from "react";
import { Fingerprint, Users, UserCog, X } from "lucide-react";
import { C } from "./data";
import { Serif } from "./ui";

const STEPS = [
  { icon: Fingerprint, title: "Hold to panic", body: "In an emergency, press and hold the big red button for 3 seconds. We instantly dispatch armed response with your live location." },
  { icon: Users, title: "Build your household", body: "Invite your family so everyone carries the panic button \u2014 and you can see each other on the live family map." },
  { icon: UserCog, title: "Complete your profile", body: "Add your vehicle, home and medical details. Responders see them the moment they arrive, so they can help you faster." },
];

export default function CoachMarks({ onDone }) {
  const [i, setI] = useState(0);
  const last = i === STEPS.length - 1;
  const s = STEPS[i];
  const Icon = s.icon;
  return (
    <div data-testid="coach-overlay" style={{ position: "absolute", inset: 0, zIndex: 50, background: "rgba(11,30,59,0.82)", backdropFilter: "blur(4px)", display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: 20 }}>
      <button onClick={onDone} data-testid="coach-skip"
        style={{ position: "absolute", top: 18, right: 18, display: "inline-flex", alignItems: "center", gap: 5, background: "rgba(255,255,255,0.14)", color: "#fff", border: 0, borderRadius: 999, padding: "7px 13px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
        Skip <X size={13} />
      </button>
      <div style={{ background: C.body, borderRadius: 20, padding: "26px 22px 22px", boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
        <div style={{ width: 52, height: 52, borderRadius: 14, background: `${C.red}14`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
          <Icon size={26} color={C.red} />
        </div>
        <Serif size={24} style={{ marginBottom: 8 }} data-testid="coach-title">{s.title}</Serif>
        <div style={{ fontSize: 14, color: C.slate, lineHeight: 1.55, marginBottom: 22 }}>{s.body}</div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", gap: 6 }}>
            {STEPS.map((_, k) => (
              <span key={k} style={{ width: k === i ? 20 : 7, height: 7, borderRadius: 999, background: k === i ? C.red : "rgba(26,30,36,0.18)", transition: "width 0.2s" }} />
            ))}
          </div>
          <button onClick={() => (last ? onDone() : setI(i + 1))} data-testid={last ? "coach-done" : "coach-next"}
            style={{ padding: "12px 22px", background: C.red, color: "#fff", border: 0, borderRadius: 999, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
            {last ? "Got it" : "Next \u2192"}
          </button>
        </div>
      </div>
    </div>
  );
}
